import type { QueryClient } from '@tanstack/react-query'

import { useAuthStore } from '@/stores/auth-store'

/**
 * When the user switches org (TeamSwitcher), the API client starts sending a new
 * `X-Organization-Id`. Cached React Query data from the previous org would otherwise
 * stay on screen until stale — invalidate active observers so the current page refetches.
 */
export function subscribeActiveOrganizationInvalidateQueries(
  queryClient: QueryClient
): () => void {
  return useAuthStore.subscribe((state, prevState) => {
    const next = state.auth.activeOrganizationId
    const prev = prevState.auth.activeOrganizationId
    if (next === prev) return

    void queryClient.invalidateQueries({ refetchType: 'active' })
  })
}
